import { render, staticRenderFns } from "./CMSImage.vue?vue&type=template&id=0825ff13"
import script from "./CMSImage.vue?vue&type=script&lang=js"
export * from "./CMSImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports